"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _config = _interopRequireDefault(require("./api-extension/config"));
var _config2 = _interopRequireDefault(require("./api-group/config"));
var _config3 = _interopRequireDefault(require("./api-test/config"));
var _config4 = _interopRequireDefault(require("./app/config"));
var _config5 = _interopRequireDefault(require("./connector/config"));
var _config6 = _interopRequireDefault(require("./crate/config"));
var _config7 = _interopRequireDefault(require("./custom/config"));
var _config8 = _interopRequireDefault(require("./data-weave-library/config"));
var _config9 = _interopRequireDefault(require("./evented-api/config"));
var _config10 = _interopRequireDefault(require("./example/config"));
var _config11 = _interopRequireDefault(require("./extension/config"));
var _config12 = _interopRequireDefault(require("./external-library/config"));
var _config13 = _interopRequireDefault(require("./gcl/config"));
var _config14 = _interopRequireDefault(require("./graphql/config"));
var _config15 = _interopRequireDefault(require("./http-api/config"));
var _config16 = _interopRequireDefault(require("./policy/config"));
var _config17 = _interopRequireDefault(require("./policy-implementation/config"));
var _config18 = _interopRequireDefault(require("./raml-fragment/config"));
var _config19 = _interopRequireDefault(require("./rest-api/config"));
var _config20 = _interopRequireDefault(require("./rpa-activity-template/config"));
var _config21 = _interopRequireDefault(require("./rpa-process-template/config"));
var _config22 = _interopRequireDefault(require("./ruleset/config"));
var _config23 = _interopRequireDefault(require("./soap-api/config"));
var _config24 = _interopRequireDefault(require("./synthetic/config"));
var _config25 = _interopRequireDefault(require("./template/config"));
var _config26 = _interopRequireDefault(require("./vdp/config"));
// this file was autogenerated, do not modify

var configs = {
  'api-extension': _config.default,
  'api-group': _config2.default,
  'api-test': _config3.default,
  'app': _config4.default,
  'connector': _config5.default,
  'crate': _config6.default,
  'custom': _config7.default,
  'data-weave-library': _config8.default,
  'evented-api': _config9.default,
  'example': _config10.default,
  'extension': _config11.default,
  'external-library': _config12.default,
  'gcl': _config13.default,
  'graphql': _config14.default,
  'http-api': _config15.default,
  'policy': _config16.default,
  'policy-implementation': _config17.default,
  'raml-fragment': _config18.default,
  'rest-api': _config19.default,
  'rpa-activity-template': _config20.default,
  'rpa-process-template': _config21.default,
  'ruleset': _config22.default,
  'soap-api': _config23.default,
  'synthetic': _config24.default,
  'template': _config25.default,
  'vdp': _config26.default
};
var _default = exports.default = configs;
//# sourceMappingURL=config.js.map